/* トップページ stay */
var swiper1 = new Swiper('.slider-stay', {
  loop: true,
  spaceBetween: 8,
  // SPではautoplayさせないことになったので擬似的に設定
  autoplay: {
    delay: 99999
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  breakpoints: {
    768: {
      speed: 12000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
      slidesPerView: 3,
      spaceBetween: 18
    }
  }
});

// スライダーの枚数が4枚未満のときはスライドさせないようにする。
// スライドはループで複製されてしまうので、スライダーが起動する前にスライドの枚数を取得する必要がある。
// なお、SP表示時はスライドである必要があるためタブレット以上の幅で実行する。
$('.c-slider').each(function () {
  var width = window.innerWidth;
  var slidesLength = $(this).find('.swiper-slide').length;
  if (slidesLength < 4 && width > 767) {
    $(this).addClass('js-slider-disable');
  }
});

/* 共通コンポーネント（プラン/ピックアップの自動スクロール） */
// 上でdisableしたコンテナについては除外する。
var swiper2 = new Swiper('.c-slider:not(.js-slider-disable)', {
  loop: true,
  centeredSlides: true,
  slidesPerView: 1,
  spaceBetween: 8,
  // SPではautoplayさせないことになったので擬似的に設定
  autoplay: {
    delay: 99999
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  breakpoints: {
    768: {
      speed: 12000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
      slidesPerView: 4,
      spaceBetween: 32
    }
  }
});

/* トップページ restaurant & bar */
// サムネイル用のスライダー
var swiper3_thumbnail = new Swiper('.slider-restaurant-thumbnail', {
  slidesPerView: 6,
  watchSlidesVisibility: true,
  watchSlidesProgress: true
});

// メイン画像用のスライダー
var swiper3 = new Swiper('.slider-restaurant', {
  effect: 'fade',
  speed: 3000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false
  },
  thumbs: {
    swiper: swiper3_thumbnail
  },
  on: {
    init: function init() {
      $('[data-restaurant=0]').fadeIn();
    },
    // スライド切り替えと同時に紹介文のコンテンツも切り替える
    activeIndexChange: function activeIndexChange() {
      var index = this.activeIndex;
      $('.switch-container').hide();
      $('[data-restaurant=' + index + ']').fadeIn();
    }
  }
});

// サムネイルホバー時にスライドを切り替える
$('.slider-restaurant-thumbnail .swiper-slide').on('mouseover', function () {
  swiper3.slideTo($(this).index());
});

/* ファーストビュー用スライダー（客室詳細ページ・会議場詳細ページで使用） */
// サムネイル用のスライダー
var swiper4_thumbnail = new Swiper('.slider-fv-thumbnail', {
  slidesPerView: 'auto',
  watchSlidesVisibility: true,
  watchSlidesProgress: true
});

// メイン画像用のスライダー
var swiper4 = new Swiper('.slider-fv', {
  effect: 'fade',
  speed: 3000,
  loop: true,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  thumbs: {
    swiper: swiper4_thumbnail
  }
});

/* ファーストビュー用スライダー（ウェディングレポート詳細ページで使用） */
var swiper5 = new Swiper('.slider-wedding-fv', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 8,
  centeredSlides: true,
  speed: 1000,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  },
  breakpoints: {
    768: {
      slidesPerView: 1.4
    }
  }
});